import {
  take,
  put,
  call,
  cancelled,
  fork,
  delay,
  select,
} from 'redux-saga/effects';
import { eventChannel, END } from 'redux-saga';

import * as popup from '../../ui/popup';
import { appointmentDetailsActions } from '../appointment-details';
import { selectPaymentDelaySeconds } from '../../data/selectors';
import { PAYA_ORIGIN } from '../../../constants/env';

export function handlePostMessage() {
  return eventChannel(emitter => {
    window.addEventListener('message', receiveMessage, false);
    function receiveMessage(event) {
      if (event.origin !== PAYA_ORIGIN) return;
      const payload = JSON.parse(event.data);
      emitter(payload);
      emitter(END);
    }

    return () => {
      window.removeEventListener('message', receiveMessage, false);
    };
  });
}

export default function* payaPaymentSaga() {
  const delaySeconds = yield select(selectPaymentDelaySeconds);

  const postMessageChannel = yield call(handlePostMessage);

  yield fork(function* paymentTimeout() {
    yield delay(delaySeconds * 1000);
    yield put(appointmentDetailsActions.paymentTimeout());
    yield put(popup.actions.hide());
  });

  try {
    while (true) {
      const result = yield take(postMessageChannel);

      /**  PAYMENT ERROR    */
      if (result.status_id === 301) {
        yield put(appointmentDetailsActions.paymentFail());
      }
      /**  PAYMENT SUCCESS  */
      if (result.status_id === 102) {
        yield put(appointmentDetailsActions.paymentSuccess());
      }

      yield put(popup.actions.hide());
    }
  } finally {
    if (yield cancelled()) {
      postMessageChannel.close();
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/healthboard/sagas/paya-payment-saga.js